'use client'

import React from 'react'

import EncoderLayout from '../EncoderLayout'
import decodeBase32 from './decodeBase32'


export default function Base32Decoder() {
  return (
    <EncoderLayout
      encode={decodeBase32}
    />
  )
}
